module.exports = __webpack_public_path__ + "static/media/renting-in-your-place.94cddd8d.md";